namespace TabAurous.Administration {
    export interface NavigationRow {
        MenuId?: number;
        MenuOrder?: number;
        Module?: string;
        SubMenu?: string;
        Name?: string;
        Controller?: string;
        Icon?: string;
        IsParent?: boolean;
        IsSubParent?: boolean;
    }

    export namespace NavigationRow {
        export const idProperty = 'MenuId';
        export const nameProperty = 'Module';
        export const localTextPrefix = 'Administration.Navigation';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            MenuId = "MenuId",
            MenuOrder = "MenuOrder",
            Module = "Module",
            SubMenu = "SubMenu",
            Name = "Name",
            Controller = "Controller",
            Icon = "Icon",
            IsParent = "IsParent",
            IsSubParent = "IsSubParent"
        }
    }
}
